// extracted by mini-css-extract-plugin
export default {"imgContain":"jG","content":"kG","titleAndImage":"lG","title":"mG","text":"nG","rhodeTitle":"oG","shortHR":"pG","modal_root":"qG","x_mark":"rG","flavorStickModal":"sG","greenBox":"tG"};
    if(module.hot) {
      // 1715091679298
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  